export const UseConvertImageToBase64 = (imageUrl) => {
  const newImage = `data:image/png;base64,${imageUrl}`;
  return newImage;
};
// UseConvertImageToBase64(imageUrlNew)